module.exports = __webpack_public_path__ + "static/media/menu-default.978b5728.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/menu-default.svg
// module id = 413
// module chunks = 0